import { FormInstance, message } from 'antd';
import { CATEGORY_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { CategoryInterface } from 'type/categoryType';

class CategoryService {
  constructor(private apiService: ApiService<CategoryInterface>) {}

  public async fetch(
    params: URLSearchParams
  ): Promise<{ data: CategoryInterface[]; count: number }> {
    const { results, count } = await this.apiService.fetch(params);
    return { data: results, count };
  }

  public async createCategory(form: FormInstance): Promise<CategoryInterface> {
    try {
      const category = form.getFieldsValue();
      category.name = category.name.toLowerCase();
      return await this.apiService.create(category);
    } catch (error) {
      message.error('Failed to create : ' + error);
      throw error;
    }
  }

  public async updateCategory(id: number, form: FormInstance): Promise<CategoryInterface> {
    try {
      const category = form.getFieldsValue();
      category.name = category.name.toLowerCase();
      return await this.apiService.update(id, category);
    } catch (error) {
      message.error('Failed to update : ' + error);
      throw error;
    }
  }
}

export const categoryService = new CategoryService(new ApiService(CATEGORY_API_PATH));
